var _stop, _stop2, _path, _path2, _path3, _path4, _ellipse, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgGear(props) {
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210.6 210.6"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: -403.41,
    y1: 1375.71,
    x2: -403.41,
    y2: 1375.1,
    gradientTransform: "matrix(96.02 0 0 -192.64 38784.4 265085.18)",
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03a7fd"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4600dc"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: _id2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-79 128.753 99.188)",
    fill: "none",
    d: "M94 65.99h69.51v66.39H94z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 522"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 25-2",
    d: "M104.2 1.26A103.34 103.34 0 11.87 104.6 103.34 103.34 0 01104.2 1.26z",
    fill: "#dcdede"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 261",
    d: "M148.6 181.51c.94-.55 1.88-1.11 2.79-1.68a9.06 9.06 0 0110.44.54l.12.12a9.06 9.06 0 0011.73-.46l.25-.24a9 9 0 001.32-11.59l-.17-.25a9 9 0 01.24-10.37q1.94-2.67 3.69-5.46a9.05 9.05 0 019.64-4.07 9 9 0 0010.4-5.52l.16-.39a9 9 0 00-3.85-10.95l-.3-.19a9 9 0 01-4.26-9.42q.62-3.3 1-6.65a9.05 9.05 0 016.91-7.86 9 9 0 007-9.43v-.5a9 9 0 00-8.2-8.24h-.28a9 9 0 01-7.92-6.67q-.89-3.28-2-6.52a9 9 0 012.82-10l.08-.06a9 9 0 002.15-11.48l-.27-.47a9 9 0 00-11-3.88H181a9 9 0 01-10.09-2.59q-2.23-2.61-4.63-5A9.06 9.06 0 01164.3 32l.12-.24a9 9 0 00-3-11.23l-.41-.29a9.05 9.05 0 00-11.66 1.3h0a9 9 0 01-10.25 2q-3.1-1.31-6.3-2.44a9.05 9.05 0 01-6-8.39v-.36a9 9 0 00-7.58-8.8l-.42-.06a9 9 0 00-10 6.24 9 9 0 01-8.34 6.34c-2.19.08-4.39.23-6.58.47a9 9 0 01-9.08-5l-.14-.27A9 9 0 0074 6.65l-.33.11a9 9 0 00-6.25 9.9v.17a9.07 9.07 0 01-4.75 9.31c-.95.51-1.91 1-2.85 1.58s-1.89 1.11-2.82 1.69a9.08 9.08 0 01-10.44-.55l-.13-.11a9 9 0 00-11.71.44l-.26.23A9.05 9.05 0 0033.15 41l.17.25a9.06 9.06 0 01-.21 10.37c-1.3 1.77-2.53 3.6-3.69 5.46a9 9 0 01-9.67 4.07 9 9 0 00-10.39 5.53l-.15.39A9 9 0 0013 78l.31.18a9 9 0 014.25 9.42q-.62 3.3-1 6.65a9 9 0 01-6.91 7.86h0a9.05 9.05 0 00-7 9.43v.5a9 9 0 008.2 8.24h.27a9 9 0 018.05 6.72c.59 2.18 1.27 4.36 2 6.52a9 9 0 01-2.8 10l-.08.07a9 9 0 00-2.15 11.48l.28.47a9 9 0 0011 3.88h.1A9 9 0 0137.65 162c1.49 1.74 3 3.42 4.63 5a9 9 0 011.81 10.2l-.11.24a9 9 0 003 11.23l.41.28a9 9 0 0011.66-1.29 9 9 0 0110.26-2.06c2.06.91 4.14 1.73 6.25 2.48a9 9 0 016 8.4v.36a9 9 0 007.58 8.8l.42.05a9 9 0 0010-6.25 9.08 9.08 0 018.37-6.33q3.29-.1 6.57-.47a9.06 9.06 0 019.1 5l.14.28a9 9 0 0010.7 4.65l.33-.1a9.06 9.06 0 006.23-9.91v-.17a9.07 9.07 0 014.74-9.32c1-.51 1.91-1 2.86-1.58M38 142.84c-21.34-37-9-84.07 27.58-105.19s83.55-8.26 104.9 28.71 9 84.08-27.59 105.2S59.31 179.83 38 142.85",
    fill: "#fff",
    stroke: "#1253fa",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 236",
    d: "M76.44 107.05a56.87 56.87 0 007-80.12l-1-1.15A58.69 58.69 0 0059.23 9.71a12.45 12.45 0 01-4.89 5.77c-3.92 2.64-7.79 5.36-11.57 8.22a107.71 107.71 0 00-17.42 16.86c-4 5.33-9.28 11.43-12 17.5C10 66.31 6.09 74.75 4.76 83.55 2.53 91.46.31 99.69 1.18 107.14c1.63 10.86 4.44 27.11 8.63 37.28 2.35 5.44 5.71 13.47 7 15.16 4.85 6.53 9 9.52 12.22 14.32s7.72 5.67 11.16 10.32c1.77 2.4 7.08 3.14 8.78 5.59 1.08 1.56 2 3.16 3 4.8h.1a23.68 23.68 0 0112.63 7.72 57.06 57.06 0 0011.83-95.29z",
    fill: "url(#".concat(_id, ")")
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 237",
    d: "M39.19 26.89h-1.21a8.7 8.7 0 01-2.57 2.3A81.7 81.7 0 0024.13 41 90.85 90.85 0 0017 52c-1.13 2.07-2.17 4.18-3.31 6.24-1 1.77-1.9 3.55-2.73 5.38A59.9 59.9 0 008.32 73.7a50.37 50.37 0 01-.74 3.45 35.07 35.07 0 1031.61-50.26z",
    fill: "#fbfbfb"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.64,
    cy: 84.34,
    rx: 11.65,
    ry: 11.43,
    fill: "#1d1d1b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 134",
    d: "M0 105.29A105.3 105.3 0 11105.29 210.6 105.3 105.3 0 010 105.29zM105 4.63A101.36 101.36 0 10206.34 106 101.37 101.37 0 00105 4.63z",
    fill: "#1253fa"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 521"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 520",
    clipPath: "url(#".concat(_id2, ")")
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 519"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 518",
    clipPath: "url(#".concat(_id2, ")")
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 517"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 516",
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 515",
    clipPath: "url(#".concat(_id2, ")")
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 260",
    d: "M160.48 69.94l-3.21 56.52h-.24l-15.15-17-25.41 22.67h-.45l-22.57-25.3.13-.34L119 83.81l-15.25-17.08.12-.12z",
    fill: "#1253fa",
    stroke: "#fff",
    strokeWidth: 3
  })))))))))))));
}
export default SvgGear;